import { type } from "../../types/types";

export default function reducer(
  state = { services: [], serviceDetails: {}, pagination: {} },
  action
) {
  switch (action.type) {
    case type.SET_SERVICES:
      return { ...state, ...action.services };
    case type.SET_SERVICE_DETAIL:
      return { ...state, ...action.serviceDetails };
    default:
      return { ...state };
  }
}
